import React from 'react';
import { FadeIn } from './ui';
const CARDS = [{
  icon: '💬',
  title: 'Descargarte sin filtros',
  desc: 'Decir lo que pensás sin miedo a molestar ni a ser juzgado.'
}, {
  icon: '🔒',
  title: 'Hablar de lo que no le contás a nadie',
  desc: 'Hay cosas que no le decimos ni a los más cercanos. Acá podés.'
}, {
  icon: '🧠',
  title: 'Pensar en voz alta',
  desc: 'Ordenar lo que tenés adentro poniéndolo en palabras. Eso ayuda más de lo que creés.'
}, {
  icon: '🔍',
  title: 'Entender qué te está pasando',
  desc: 'A veces no hace falta una solución. Hace falta claridad.'
}, {
  icon: '👂',
  title: 'Sentirte escuchado de verdad',
  desc: 'Sin que te interrumpan. Sin consejos no pedidos. Sin agenda propia.'
}, {
  icon: '🌙',
  title: 'Cuando más lo necesitás',
  desc: 'A las 2am, un domingo, después de una mala noticia. Siempre hay alguien.'
}];
export function WhatYouCanDo() {
  return <section className="w-full bg-[#1B2B4A] px-6 py-20 sm:py-28" data-id="element-101">
      <div className="mx-auto max-w-6xl" data-id="element-102">
        <FadeIn className="text-center" data-id="element-103">
          <h2 className="font-serif text-3xl text-white sm:text-4xl" data-id="element-104">
            ¿Para qué sirve este espacio?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-white/70" data-id="element-105">
            No hace falta saber por dónde arrancar. Solo traé lo que tenés.
          </p>
        </FadeIn>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-106">
          {CARDS.map((card, i) => <FadeIn key={card.title} delay={i % 3 * 0.08} data-id="element-107">
              <div className="h-full rounded-2xl border border-[#8BA3C7]/20 bg-[#213354] p-7 transition-colors duration-300 hover:border-[#8BA3C7]/50" data-id="element-108">
                <span className="text-3xl" aria-hidden="true" data-id="element-109">
                  {card.icon}
                </span>
                <h3 className="mt-4 font-serif text-xl text-white" data-id="element-110">
                  {card.title}
                </h3>
                <p className="mt-3 leading-relaxed text-white/70" data-id="element-111">
                  {card.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}